'use strict';

function Select(){

  /*look for any elements with the class "custom-select":*/
  let selector = document.getElementsByClassName("js-selector");

  for (let i = 0; i < selector.length; i++) {

    let selElmnt = selector[i].getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/
    let selectDiv = document.createElement("DIV");
    selectDiv.setAttribute("class", "select-selected");

    if(selElmnt.classList.value == 'js-points'){
     selectDiv.classList.add("js-points");
    }
    selectDiv.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    selector[i].appendChild(selectDiv);
    /*for each element, create a new DIV that will contain the option list:*/
    let list = document.createElement("DIV");
    list.setAttribute("class", "select-items select-hide");

    for (let j = 0; j < selElmnt.length; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      let item = document.createElement("DIV");
      item.innerHTML = selElmnt.options[j].innerHTML;

      item.setAttribute("data-object_id", selElmnt.options[j].dataset.object_id);
      item.setAttribute("class", selElmnt.options[j].className);
      item.addEventListener("click", function(e) {
          /*when an item is clicked, update the original select box,
          and the selected item:*/
          let sel = this.parentNode.parentNode.getElementsByTagName("select")[0];
          let prev = this.parentNode.previousSibling;
          for (let i = 0; i < sel.length; i++) {

            if (sel.options[i].innerHTML == this.innerHTML) {
              sel.selectedIndex = i;
              prev.innerHTML = this.innerHTML;
              let same = this.parentNode.getElementsByClassName("same-as-selected");
              for (let k = 0; k < same.length; k++) {
                same[k].classList.remove("same-as-selected");
              }
              this.classList.add("same-as-selected");
              break;
            }
          }
          prev.click();
      });
      list.appendChild(item);
    }

    selector[i].appendChild(list);
    selectDiv.addEventListener("click", function(e) {
      if(!this.classList.contains('disabled')){

        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      }
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/

    });
  }

  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    let arrNo = [];
    let selector = document.getElementsByClassName("select-items");
    let sel = document.getElementsByClassName("select-selected");
    for (let i = 0; i < sel.length; i++) {
      if (elmnt == sel[i]) {
        arrNo.push(i)
      } else {
        sel[i].classList.remove("select-arrow-active");
      }
    }
    for (let i = 0; i < selector.length; i++) {
      if (arrNo.indexOf(i)) {
        selector[i].classList.add("select-hide");
      }
    }
  }

  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
  document.addEventListener("click", closeAllSelect);
}

export {
  Select
};
